import { visserApi } from './visserApi';
import { convertModelToFormData } from './helpers';
const getCreditureNumber = async () => {
    return await visserApi.get(`Creditor/GetIncrimentedCreditorNumber`);
};
const createCrediture = async (Crediteur) => {
    return await visserApi.post(`Creditor/CreateCreditor`, Crediteur);
};
const updateCrediture = async (Crediteur) => {
    return await visserApi.put(`Creditor/Update`, Crediteur);
};
const getAllCreditors = async () => {
    return await visserApi.get('Creditor/GetAll');
};
const getAllInternCrediteur = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return await visserApi.post(`Creditor/GetAllInternCrediteurs?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllExternCrediteur = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return await visserApi.post(`Creditor/GetAllExternCrediteurs?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getCreditureById = async (id) => {
    return await visserApi.get(`Creditor/GetByID/${id}`);
};
const createContactPerson = async (contactPerson) => {
    return await visserApi.post('Creditor/CreateContact', contactPerson);
};
const updateContactPerson = async (contactPerson) => {
    return await visserApi.put(`Creditor/UpdateContact/${contactPerson.id}`, contactPerson);
};
const deleteContactPersonById = async (id) => {
    return await visserApi.delete(`Creditor/DeleteContactById/${id}`);
};
const getContactPersonsByCreditorId = async (creditorId) => {
    return await visserApi.get(`Creditor/GetContactsByCreditorId/${creditorId}`);
};
const getContactPersonbyId = async (id) => {
    return await visserApi.get(`Creditor/GetContactById/${id}`);
};
const getAllAttachmentsByCreditorId = async (creditorId) => {
    return await visserApi.get(`Creditor/GetAllAttachmentsByCreditorId/${creditorId}`);
};
const addAttachmentsByCreditorId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('Creditor/UploadCreditorAttachment', formData);
};
const deleteCreditorAttachment = (attachmentId) => {
    return visserApi.delete(`Creditor/DeleteCreditorAttachmentById/${attachmentId}`);
};
const deleteCreditureById = async (id) => {
    return await visserApi.delete(`Creditor/Delete/${id}`);
};
const updateCreditorToPreference = async (creditorId, updatePreference) => {
    return await visserApi.put(`Creditor/UpdateCreditorToPreference/${creditorId}`, updatePreference);
};
const CreditureApi = {
    getCreditureNumber,
    createCrediture,
    updateCrediture,
    getAllCreditors,
    getAllInternCrediteur,
    getAllExternCrediteur,
    getCreditureById,
    createContactPerson,
    updateContactPerson,
    deleteContactPersonById,
    getContactPersonsByCreditorId,
    getContactPersonbyId,
    getAllAttachmentsByCreditorId,
    addAttachmentsByCreditorId,
    deleteCreditorAttachment,
    deleteCreditureById,
    updateCreditorToPreference
};
export default CreditureApi;
